module.exports = __webpack_public_path__ + "static/media/webdesign-services-img14.9d9d6d88.jpg";